<template>
    <v-row class="align-center" no-gutters :class="{'flex-grow-0': !orderTitleEdit}">
        <p v-if="isAllowToEdit" class="font-weight-regular text-caption mr-2">
            {{ `${$t('add')} ${$t('title').toLocaleLowerCase()}` }}:
        </p>
        <template v-if="!orderTitleEdit">
            <p>
                {{ order?.title }}
                <v-btn
                    v-if="isAllowToEdit"
                    size="small"
                    icon="mdi-pencil"
                    variant="text"
                    color="grey"
                    data-cy="edit"
                    @click="clickOrderTitleEdit"
                />
            </p>
        </template>
        <div v-else class="d-flex flex-grow-1 align-center">
            <v-text-field v-model="orderTitle" density="compact" hide-details class="me-1" />
            <v-btn
                icon="mdi-check-circle-outline"
                variant="text"
                color="success"
                class="ms-1 cursor-pointer"
                data-cy="send"
                :loading="loading"
                @click="saveOrderTitle"
            />
        </div>
    </v-row>
</template>
<script setup lang="ts">
    const orderTitleEdit = ref<boolean>(false)
    const orderTitle = ref<string>('')
    const loading = ref<boolean>(false)

    const app = useNuxtApp()
    const {t} = useI18n()

    const order = computed(() => {
        return runtimeStore.orderDetails
    })

    const isAllowToEdit = computed(() => {
        return (authStore.isTO1 || authStore.isAgency) && !authStore.isAccountant
    })

    const clickOrderTitleEdit = () => {
        orderTitleEdit.value = true
        orderTitle.value = order.value?.title
    }

    const saveOrderTitle = async () => {
        loading.value = true
        const data = {title: orderTitle.value}
        try {
            await app.$api.orders.put(order.value.orderId, data)
            runtimeStore.SET_ORDER_DETAILS({...order.value, ...data})
            orderTitleEdit.value = false
        } catch (e) {
            app.$toast.error(t('data_update_fail'))
        } finally {
            loading.value = false
        }
    }
</script>
